<template>
	<div class="c-sidebar-bar-credits" v-if="workspace">
		<strong>
			<span>AI Credits </span>
			<span> {{ usedCredits }}/{{ maxCredits }} </span>
		</strong>
		<span class="bar">
			<span :style="barStyle"></span>
		</span>
	</div>
</template>

<script>
export default {
	computed: {
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		maxCredits: function () {
			const AI_CREDITS_BY_PLAN = {
				TRIAL: 30,
				PRO: 150,
				BASIC: 150,
				PLUS: 400,
				AGENCY: 1000,
			};
			let planType = this.workspace.planType;
			if (this.workspace.plan === 'TRIAL') {
				planType = 'TRIAL';
			}
			const maxCredits = AI_CREDITS_BY_PLAN[planType] || 0;

			return maxCredits;
		},
		usedCredits: function () {
			const AI_CREDITS_BY_PLAN = {
				TRIAL: 30,
				PRO: 150,
				BASIC: 150,
				PLUS: 400,
				AGENCY: 1000,
			};

			let aiCredits = this.workspace.aiCredits;
			let planType = this.workspace.planType;
			if (this.workspace.plan === 'TRIAL') {
				planType = 'TRIAL';
			}
			const maxCredits = AI_CREDITS_BY_PLAN[planType] || 0;
			const usedCredits = maxCredits - (aiCredits || 0);

			return usedCredits;
		},
		barStyle: function () {
			const usedCredits = this.usedCredits;
			const maxCredits = this.maxCredits;

			// Calculate percentage of used credits relative to max
			let percentage = 0;
			if (maxCredits > 0) {
				percentage = (usedCredits / maxCredits) * 100;
			}

			// Optional: clamp between 0 and 100 to avoid overflow
			percentage = Math.max(0, Math.min(100, percentage));

			let backgroundColor = 'success'; // warning, danger
			if (percentage > 80) {
				backgroundColor = 'danger';
			} else if (percentage > 50) {
				backgroundColor = 'warning';
			}
			return {
				width: `${percentage}%`,
				'background-color': `var(--color-${backgroundColor})`,
			};
		},
	},
};
</script>

<style lang="scss">
.c-sidebar-bar-credits {
	//margin-bottom: 0.5rem;

	strong {
		display: flex;
		justify-content: space-between;
		margin-bottom: 0.25rem;
		font-size: var(--font-size-xxs);
		color: rgba(255, 255, 255, 0.9);
		font-weight: 450;

		span {
			&:last-of-type {
				font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
					'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0,
					'ss04', 'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0,
					'cv03' 0, 'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0,
					'cv10' 0, 'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0,
					'aalt' 0, 'calt', 'ccmp', 'locl', 'kern';
			}
		}
	}

	.bar {
		display: block;
		width: 100%;
		height: 4px;
		border-radius: 4px;
		background-color: var(--color-bg-94);

		> span {
			display: block;
			height: 100%;
			border-radius: 4px;
			background-color: var(--color-success);
		}
	}
}
</style>
